import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@material-ui/core';
import { APPROVED_STATUS_LABELS } from './constants';

const getApprovedStatus = (statusCode) => APPROVED_STATUS_LABELS[statusCode] || "";

const CompanyProductBox = ({ product, button }) => {
    return (
        <Grid item xs={12} sm={6} md={3} style={{ marginBottom: '20px' }}>
            <Card variant="outlined" style={{ borderTop: "3px solid #EBBB5B", height: '100%' }}>
                <CardContent style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                    <Box textAlign="center" mb={2}>
                        <img
                            src={product.imageUrl}
                            alt="Loading..."
                            height="75px"
                        />
                    </Box>

                    <Typography variant="h5" component="h3" align="center">
                        {product.name}
                    </Typography>

                    <Typography variant="body2" color="textSecondary" align="center" style={{ minHeight: '60px' }}>
                        {product.details}
                    </Typography>

                    <ul className="list-group list-group-unbordered mb-3">
                        <li className="list-group-item">
                            <b>Homepage</b>
                            <span className="float-right">
                                <a href={product.homePage} target="_blank" rel="noopener noreferrer">{product.companyName}</a>
                            </span>
                        </li>
                        <li className="list-group-item">
                            <b>Benötigte Likes</b>
                            <span className="float-right">{product.price}</span>
                        </li>
                        <li className="list-group-item">
                            <b>Tage zum deserven</b>
                            <span className="float-right">
                                {product.timeperiode}
                            </span>
                        </li>
                        <li className="list-group-item">
                            <b>Ablaufdatum</b>
                            <span className="float-right">{new Date(product.timeperiodeTo).toLocaleDateString('de-DE')}</span>
                        </li>
                        <li className="list-group-item">
                            <b>Status</b>
                            <span className="float-right">{getApprovedStatus(product.approvedStatus)}</span>
                        </li>
                    </ul>

                    {button}
                </CardContent>
            </Card>
        </Grid>
    );
};

export default CompanyProductBox;
